
const config = {

    apiKey:     process.env.REACT_APP_API_KEY,
    host:       process.env.REACT_APP_API_HOST,
    apiPort:    process.env.REACT_APP_API_PORT || "50521",
    apiPath:    "api",
    mediaPath:  "media",
    authCookie: "user-token",
    
    // Протокол для API запросов (http для локальной разработки, https для продакшена)
    // По умолчанию https для безопасности
    protocol:   process.env.REACT_APP_API_PROTOCOL || "https",

    // ==========================================
    // SEO & АНАЛИТИКА
    // ==========================================
    
    // Google Analytics 4 ID (формат: G-XXXXXXXXXX)
    // Получить можно в https://analytics.google.com
    googleAnalyticsId: process.env.REACT_APP_GA_ID || '',
    
    // Yandex Metrika ID (формат: XXXXXXXX)
    // Получить можно в https://metrika.yandex.ru
    yandexMetrikaId: process.env.REACT_APP_YM_ID || '',
    
    // Домен сайта (для SEO)
    // ВАЖНО: Замените на реальный домен перед деплоем!
    siteUrl: process.env.REACT_APP_SITE_URL || 'https://your-domain.ru'

};

/**
 * Строит полный URL для API запросов
 * @returns {string} Полный базовый URL API (например: https://api.example.com:443/api)
 */
config.getApiBaseUrl = function() {
    return `${this.protocol}://${this.host}:${this.apiPort}/${this.apiPath}`;
};

/**
 * Строит полный URL для медиа-файлов
 * @param {string} filename - Имя файла
 * @returns {string} Полный URL медиа-файла (например: https://api.example.com/media/filename.jpg)
 */
config.getMediaUrl = function(filename) {
    if (!filename) return null;
    return `${this.protocol}://${this.host}/${this.mediaPath}/${filename}`;
};

/**
 * Возвращает полный URL сайта
 * @returns {string} URL сайта
 */
config.getSiteUrl = function() {
    return this.siteUrl;
};

export default config;
